"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _sizes = require("HubStyleTokens/sizes");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIHeader = _interopRequireDefault(require("../layout/UIHeader"));

var _omit = _interopRequireDefault(require("../utils/underscore/omit"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-bottom: ", ";\n  padding-top: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Subheader = (0, _styledComponents.default)(_UIHeader.default).withConfig({
  displayName: "UISubheader__Subheader",
  componentId: "w00l24-0"
})(_templateObject(), _sizes.DISTANCE_MEASUREMENT_MEDIUM);

function UISubheader(_ref) {
  var props = (0, _extends2.default)({}, _ref);
  return _react.default.createElement(Subheader, (0, _extends2.default)({}, props, {
    fullWidth: true,
    flush: true,
    use: "condensed"
  }));
}

UISubheader.propTypes = (0, _extends2.default)({}, (0, _omit.default)(_UIHeader.default.propTypes, ['flush', 'fullWidth', 'headingLevel', 'use']), {
  headingLevel: _propTypes.default.oneOf(['h2', 'h3', 'h4', 'h5', 'h6'])
});
UISubheader.defaultProps = {
  headingLevel: 'h2',
  role: 'presentation'
};
UISubheader.displayName = 'UISubheader';
var _default = UISubheader;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/layout/UISubheader.js
// module id = 440
// module chunks = 209 210 211 212